import { Context, css, Global, Link, mobile, styled, Text } from '@obvio/app'
import { Button, Stack } from '@obvio/ui'

import { RegisterModal, useModal } from '@/components/CommingSoon/RegisterModal'
import { Cursor } from '@/components/Cursor'

import type { ReactElement } from 'react'

const MobileLink = styled(Link)`
  display: none;
  @media ${mobile} {
    display: block;
  }
`

const RegisterButton = styled(Button)`
  all: unset;
  text-decoration: underline;
  letter-spacing: 0.1rem;
  height: auto;
  text-align: right;
`

const StyledDiv = styled.div`
  ${(theme) => [theme.overlay, theme.flexCenter, theme.pageWidth]};
  color: white;
  text-align: center;

  a {
    text-decoration: none;
  }
`

const DesktopSpan = styled(Stack)`
  @media ${mobile} {
    display: none;
  }
`

const DesktopLink = styled(Link)`
  @media ${mobile} {
    display: none;
  }
`

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  position: fixed;
  inset: ${(theme) => theme.spacing.large};
  bottom: unset;
  text-transform: uppercase;
  letter-spacing: 0.1rem;

  > span:first-of-type {
    justify-content: flex-start;
    text-align: left;
  }

  @media ${mobile} {
    inset: ${(theme) => theme.spacing.medium};
    bottom: unset;
  }
`

const Bottom = styled(Top)`
  inset: ${(theme) => theme.spacing.large};
  top: unset;

  @media ${mobile} {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: ${(theme) => theme.spacing.medium};
    column-gap: ${(theme) => theme.spacing.extraLarge};
    inset: ${(theme) => theme.spacing.medium};
    top: unset;
  }
`

const TextButton = styled(Button)`
  h2 {
    border-bottom: 2px solid white;
    text-transform: none;
    line-height: 100%;
    padding-bottom: ${(theme) => theme.spacing.extraSmall};
  }
  padding: 0;
  height: auto;
  margin-bottom: ${(theme) => theme.spacing.medium} !important;
`

const SecondFont = styled.h2`
  font-family: ${(theme) => theme.font};
`

const Content = styled(Stack)`
  justify-content: center;
  align-items: center;
  h2 {
    margin-bottom: 0;
  }
  p {
    letter-spacing: 0.1em;
  }
`

const TextLogo = styled(Stack)`
  margin-bottom: ${(theme) => theme.spacing.medium};
`

const mailHref = 'mailto:jakub@fijewski.com'
const telHref = 'tel:516-450-060'

const globalStyle = css`
  body {
    background-color: ${(theme) => theme.background};
  }
`

function ComingSoon(): ReactElement {
  const { show } = useModal(RegisterModal.PARAM)
  return (
    <Context name="event" render="div">
      <Global styles={globalStyle} />
      <Cursor />
      <StyledDiv>
        <Top>
          <DesktopSpan>
            <DesktopLink href={mailHref}>jakub@fijewski.com</DesktopLink>
            <DesktopLink href={telHref}>tel: +48 516 450 060</DesktopLink>
          </DesktopSpan>
          <DesktopSpan>
            <span>Konstancin | Zurych | Miami | Warsaw</span>
          </DesktopSpan>
          <MobileLink href={mailHref}>MAIL</MobileLink>
          <MobileLink href={telHref}>TEL</MobileLink>
        </Top>
        <Content kind="vertical" spacing="extraSmall">
          <TextLogo>
            <Text tag="h2">FIJEWSKI</Text>
            <SecondFont>GALLERY</SecondFont>
          </TextLogo>
          <Text tag="h2">Grand Opening coming in September</Text>
          <TextButton kind="transparent" onClick={show}>
            <Text tag="h2">Stay tuned and get an alert</Text>
          </TextButton>
          <Text>SEE YOU SOON</Text>
        </Content>
        <Bottom>
          <span>New website coming soon.</span>
          <RegisterButton kind="transparent" onClick={show}>
            GET AN ALERT FOR GRAND OPENING
          </RegisterButton>
        </Bottom>
      </StyledDiv>
      <RegisterModal />
    </Context>
  )
}

export default ComingSoon
